import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  showSpinner = false;

  constructor(private service: NgxSpinnerService) {}

  open(name: string = 'chart') {
    setTimeout(() => {
      this.showSpinner = true;
      this.service.show(name);
    });
  }

  close(name: string = 'chart') {
    setTimeout(() => {
      this.showSpinner = false;
      this.service.hide(name);
    });
  }

  reset() {
    this.showSpinner = false;
    this.service.hide();
  }
}
